import React from 'react'
import { useSelector } from 'react-redux'
import I18n from 'APP/Services/i18n'

import { selectEpharmacyExternalServicesByProvider } from 'APP/Redux/PatientRedux'
import { usePillwayNavigation } from 'APP/Lib/PillwayHelpers'

import ListItem from 'APP/Converse/ListItem'

const PharmacyAccountMenuItem = () => {
  const epharmacyPillwayExternalServices = useSelector((state) =>
    // @ts-expect-error: this method definitely allows two arguments
    selectEpharmacyExternalServicesByProvider(state, 'pillway')
  )
  const navigateToPillway = usePillwayNavigation()

  return (
    <>
      {
        // @ts-expect-error: scribe is not typed in MA yet
        epharmacyPillwayExternalServices?.map((pharmacy) => (
          <ListItem
            key={`pharmacy-account-${pharmacy.id}`}
            analyticsName="pharmacy-account"
            testID="PHARMACY_ACCOUNT_SCREEN_PHARMACY_MENU_ITEM"
            title={I18n.t('AccountScreen.pharmacyAccount')}
            onPress={() => navigateToPillway(pharmacy)}
          />
        ))
      }
    </>
  )
}

export default PharmacyAccountMenuItem
